import React from 'react';
import { getAuth } from 'firebase/auth';
import CalendarView from './CalendarView';

function CalendarPage() {
    const auth = getAuth();

    return (
        <div className="calendar-page-container" style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
            <CalendarView auth={auth} />
        </div>
    );
}

export default CalendarPage;

